import { Injectable, Optional } from '@angular/core';
import { Size, ViewerPDFOverlayViewProviderService } from '@bukio/viewer';

import { PDFDrawingService } from './pdf-drawing.service';
import { UIStateService } from './ui-state.service';

@Injectable({
  providedIn: 'root',
})
export class PDFOverlayViewProviderService extends ViewerPDFOverlayViewProviderService {
  constructor(
    @Optional() private pdfDrawingService?: PDFDrawingService,
    @Optional() private uiState?: UIStateService
  ) {
    super();
  }

  override getOverlayView(iid: string, pageSize: Size): Element | null {
    if (this.uiState && this.uiState.showDrawing === false) {
      return null;
    }
    return this.pdfDrawingService?.getOverlayView(iid, pageSize) ?? null;
  }

  override willEndDisplayingOverlayView(element: Element): void {
    return this.pdfDrawingService?.willEndDisplayingOverlayView(element);
  }
}
